import Link from '../Link/Link';
import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext';
import style from './footer.module.scss';

const Footer = () => {
  const { settings } = useAccessibility();

  const isDefaultContrast = settings.contrast === 'default';
  
  // Цвет красного как на флаге РФ - #DA291C
  const theme = {
    background: isDefaultContrast ? '#da291c' : '#b82218',
    backgroundHover: isDefaultContrast ? '#e83528' : '#c92a1e',
    text: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.85)',
    textMuted: 'rgba(255, 255, 255, 0.6)',
    border: 'rgba(255, 255, 255, 0.2)',
    hoverText: '#ffffff',
    accent: 'rgba(255, 255, 255, 0.12)',
  };

  const footerLinks = [
    { label: 'Новости', href: '/news/' },
    { label: 'Отделения', href: '/units/' },
    { label: 'Направления', href: '/programs/' },
    { label: 'Тренеры', href: '/team/' },
  ];

  const socialLinks = [
    { label: 'Вконтакте', href: 'https://vk.com/club227351180' },
    { label: 'Telegram', href: 'https://t.me/sambo_23rus' },
    { label: 'Max', href: 'https://max.ru/id2311365872_gos' },
  ];

  const legalLinks = [
    { label: 'Обратная связь', href: '/feedback' },
    { label: 'Раскрытие информации', href: 'about/main/' },
    { label: 'Положение об обработке персональных данных', href: 'about/documents/' },
    { label: 'Политика обработки персональных данных', href: 'about/documents/' },
  ];

  return (
    <footer 
      className={style.footer} 
      style={{ 
        background: theme.background,
        color: theme.text,
      }}
    >
      {/* Декоративная белая полоса сверху как на флаге */}
      <div className={style.flagStripe}></div>

      <div className={style.upper}>
        <div className={style.left}>
          {/* Меню */}
          <div className={style.column}>
            <h3 className={style.sectionHeader}>Меню</h3>
            <div className={style.linkGroup}>
              {footerLinks.map((link) => (
                <Link 
                  key={link.href}
                  children={link.label}
                  href={link.href}
                  color={theme.textSecondary}
                  hoverColor={theme.hoverText}
                />
              ))}
            </div>
          </div>

          {/* Социальные сети */}
          <div className={style.column}>
            <h3 className={style.sectionHeader}>Социальные сети</h3>
            <div className={style.linkGroup}>
              {socialLinks.map((link) => (
                <Link 
                  key={link.href}
                  children={link.label}
                  href={link.href}
                  color={theme.textSecondary}
                  hoverColor={theme.hoverText}
                />
              ))}
            </div>
          </div>

          {/* Контакты */}
          <div className={style.column}>
            <h3 className={style.sectionHeader}>Контакты</h3>
            <div className={style.contactInfo}>
              <span className={style.contactLabel}>Телефон:</span>
              <span className={style.contactValue}>+7 (861) 990-55-10</span>
              <span className={style.contactLabel}>Email:</span>
              <span className={style.contactValue}>sambo-krasnodar@mail.ru</span>
              <span className={style.contactSmall}>Пн-Пт 9:00-18:00</span>
            </div>
          </div>
        </div>
      </div>

      {/* Нижняя часть с юридическими ссылками */}
      <div 
        className={style.lower} 
        style={{ borderTop: `1px solid ${theme.border}` }}
      >
        {legalLinks.map((link) => (
          <Link
            key={link.href}
            children={link.label}
            href={link.href}
            fontSize="0.65rem"
            fontWeight="300"
            color={theme.textMuted}
            hoverColor={theme.hoverText}
          />
        ))}
      </div>
    </footer>
  );
};

export default Footer;